<template>
  <div>
    <div class="collapse">
      <div
        class="collapse-item"
        v-for="(item, index) in obj['itemList' + tab]"
        :key="index"
        @click="coll(index)"
      >
        <div class="title">
          <p>{{ item.head }}</p>
          <span v-if="!item.open"
            ><img
              style="width: 18rpx; height: 11rpx"
              src="@/assets/img/Vector110.png"
              alt=""
          /></span>
          <span v-else
            ><img
              style="width: 18rpx; height: 11rpx"
              src="@/assets/img/Frame272.png"
              alt=""
          /></span>
        </div>
        <div class="item-text" v-show="item.open">{{ item.body }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      obj: {
        itemList1: [
          {
            head: "取消订单后什么时候退款？",
            body: "回答：由于风控或商家原因关闭的订单，支付部分会在1-3个工作日退还至您的支付账户。",
            open: false,
            disabled: true,
          },
          {
            head: "发货前的订单能不能取消？",
            body: "回答：原则上，订单审核通过后不支持取消，如商家已订货，用户申请取消订单，需用户与商家协商处理。",
            open: false,
          },
          {
            head: "订单签收需要准备什么资料？",
            body: "回答：需要本人签收，携带身份证原件并完成人脸识别签收。快递拆封时建议您录制开箱视频。",
            open: false,
          },
          {
            head: "订单到期后设备如何归还？",
            body: "回答：订单到期前，可通过「我的-我的订单-待归还-归还」获取地址并自行寄出快递后填写快递单号。",
            open: false,
          },
          {
            head: "可以提前归还吗需要赔付违约金吗？",
            body: "回答：可以提前归还，但提前归还需要赔付违约金，具体赔偿标准如下(用户与商家另外约定的情况除外)  1、二手设备赔付标准如下：(1)总租期在 6个月（不含6个月）以上 ,乙方须支付总租金50%作为违约金；(2)总租期在 3个月（不含3个月）-6个月以内（含 6个月）的，乙方须支付总租金30%作为违约金；(3)总租期在 3个月以内（含 3个月）的，乙方须支付剩余未付租金作为违约金。 2、全新设备赔付标准：“固定租期”租赁方式的订单，乙方须待租赁期满后才能退还；若乙方提前退还设备，甲方将收取商品押金的的30%作为服务费。3、定制产品赔付标准：乙方定制的产品，乙方须待租赁期满后才能退还；若乙方提前退还设备，甲方将收取商品押金的30%作为服务费。4、如上述违约金/服务费不足以补偿甲方的全部损失，不足部分由乙方承担。5、特殊情况说明：(1)如遇商家缺货，商家有权单独解除订单协议并取消订单，同时用户已支付的租金原路退还，且商家不承担任何违约责任;(2)商品详情页约定可随租随还(即可随时租用和可随时归还)的产品，用户提前归还产品给商家，无需赔付违约金。",
            open: false,
          },
          {
            head: "哪类租赁优惠券在提前归还时需要补足订单差额？",
            body: "回答：若此优惠券为首期X元券（例如:首月1元券）或X天体验券（例如:30天体验券），如用户需要提前归还商品，则必须补足订单差额，差额为用券前的订单金额减去实际支付的订单金额。",
            open: false,
          },
          {
            head: "订单到期后可以买断吗？",
            body: "回答：可在「我的-全部订单-租赁中」查看订单是否支持买断如果有「买断」按钮的，用户可随时支付买断尾款完成买断如果只有「买断」按钮的，用户可申请买断，商家同意后，用户点击「买断」按钮，即可支付买断尾款完成买断。",
            open: false,
          },
          {
            head: "订单如何续租？",
            body: "回答：订单到期前可在「我的-全部订单-租赁中」点击「续租」按钮进行续租，超过30天租期的订单需在订单到期前30天才能续租，需要帮助可以联系平台客服。",
            open: false,
          },
          {
            head: "设备损坏后维修费用的计算？",
            body: "回答：用户在设备使用期间产生的损坏可于商家协商进行赔付，最高不超过商品市场价格。",
            open: false,
          },
          {
            head: "关于运费，物流损坏问题？",
            body: "回答：运费归属问题可在下单时「商品详情页」查看，「无需归还」指订单到期后设备归用户所有。无论用户还是商家使用邮寄设备时都建议保价寄送；因快递公司原因（丢件等）导致未正常收货或损坏，责任由发货人承担，由发货人联系快递公司协商处理用户签收时需当场开箱验收，商家收到归还的设备后需24小时内完成检测。",
            open: false,
          },
          {
            head: "什么时候发货？",
            body: "回答：审核通过后若无特殊情况（联系不上用户、下单地址不详细等），商家将尽快安排就近服务点发货，预计在租期起始日前48小时内发出（节假日除外），如果用户需要自取，需请提前联系商家客服并在下单时备注自提。",
            open: false,
          },
        ],
        itemList2: [
          {
            head: "如何申请免押金额度？",
            body: "回答：在【订单确认页】点击【去免押】按钮即可申请免押额度，再次过程中系统会根据您的综合信用输出参考免押额度（通过预授权后可查看），订单提交成功后，商家会根据您提交的信息进行最终审核，如最终免押额度等于或高于租赁订单押金，您无需支付押金；如最终免押额度未能完全抵扣租赁订单押金，则需支付（冻结）押金。",
            open: false,
            disabled: true,
          },
          {
            head: "实际支付、冻结的押金什么时候退还？",
            body: "回答：租赁期限届满，商家在收到设备后经检测确认无损坏后，在3个工作日内退还押金，如遇节假日则顺延。",
            open: false,
            disabled: true,
          },
          {
            head: "其他?",
            body: "回答：如您对押金的收取、扣除等有任何疑问均可通过在线客服或拨打平台热线0755-36560879联系平台客服，迪瓜租机客服将竭诚为您服务。",
            open: false,
            disabled: true,
          },
        ],
        itemList3: [
          {
            head: "故障、损坏、丢失造成的损失谁承担？",
            body: "回答：正常设备折旧（自然损耗）由商家承担。租期内设备自然产生的硬件故障由商家提供免费更换服务，软件问题由商家协助人为损坏、碰撞、划痕等问题，用户需承担设备维修费用以及维修期间的租期费用，具体维修费用由用户与商家协商决定粉碎性破坏、丢失、拆机等情况按商品详情页赔偿标准或市场价格赔偿，具体赔偿费用由用户与商家协商决定。",
            open: false,
            disabled: true,
          },
          {
            head: "设备出现故障怎么办？",
            body: "回答：设备出现故障时，请第一时间在支付宝搜索“迪瓜租机”在「我的-客服」，联系商家客服，咨询问题解决方式。",
            open: false,
            disabled: true,
          },
          {
            head: "维修费用谁承担?",
            body: "回答：因设备硬件自然损耗或自然故障所产生的费用、及配件和保养费用由商家承担。设备属人为损坏、碰撞、划痕等问题，由用户承担维修费用以及维修期间的租期费用，具体维修费用由用户与商家协商决定。",
            open: false,
            disabled: true,
          },
        ],
        itemList4: [
          {
            head: "租期计算规则？",
            body: "回答：租期是从用户签收日当天起计算（正常是按快递送到货当天，由于用户原因延误签收时间，延误时间计算在租期内）例如用户下单选择日期是18号，但20号才收到货签收，则从20号起算租期，到期日相应顺延2天再归还。",
            open: false,
            disabled: true,
          },
          {
            head: "怎么查看租金价格？",
            body: "回答：用户可在产品详情页点击「免押租」按钮，选择套餐后，系统自动计算租金，租期越长，租金价格越优惠。",
            open: false,
            disabled: true,
          },
          {
            head: "怎么开发票？",
            body: "回答：用户提交订单时，在备注处填写开票资料及发票类型，若未进行备注，请联系商家客服沟通。",
            open: false,
            disabled: true,
          },
          {
            head: "租赁优惠如何使用？",
            body: "回答：租赁优惠包括∶租赁券、延期券、买断券、特价券，具体每类租赁优惠的使用方式为∶租赁券、延期券在下单过程中满足特定商品、满减金额两个条件即可选择性使用（有多张可使用的租赁券或延期券时，可选择性使用）买断券可在买断商品过程中满足特定在租商品、满减金额两个条件即可选择性使用（有多张可使用的买断券时，可选择性使用哪1张或不使用）。",
            open: false,
            disabled: true,
          },
        ],
      },
    };
  },
  props: {
    tab: {
      default: "1",
    },
  },

  methods: {
    coll(index) {
      this.$set(
        this.obj["itemList" + this.tab][index],
        "open",
        !this.obj["itemList" + this.tab][index].open,
      );
      console.log(this.obj["itemList" + this.tab][index]);
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes animation01 {
  0% {
    height: 0px;
    padding: 0;
  }

  10% {
    height: 20rpx;
    padding: 0;
  }

  20% {
    height: 40rpx;
    padding: 0;
  }

  30% {
    height: 60rpx;
    padding: 0;
  }

  40% {
    height: 80rpx;
    padding: 0;
  }

  50% {
    height: 100rpx;
    padding: 0;
  }

  60% {
    height: 120rpx;
    padding: 0;
  }

  70% {
    height: 140rpx;
    padding: 0;
  }

  80% {
    height: 160rpx;
    padding: 0;
  }

  90% {
    height: 200rpx;
    padding: 0;
  }

  100% {
    height: 240rpx;
    padding: 0;
  }
}

.collapse {
  padding: 0 0.2rem;
  line-height: 3;

  .collapse-item {
    // height: 76rpx;

    font-size: 26rpx;

    // line-height: 76rpx;

    .title {
      height: 76rpx;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #eeeeee;
      color: #666666;
      // overflow: hidden;

      p {
        width: 90%;

        overflow: hidden; //溢出隐藏
        white-space: nowrap; //禁止换行
        text-overflow: ellipsis; //...
      }
    }

    .item-text {
      color: #999999;
      font-size: 24rpx;

      // transition: all 1s linear;
      // animation-name: animation01;
      // animation-duration: 0.2s;
      padding: 22rpx 0;

      min-height: 200rpx;
      max-height: 280rpx;
      overflow: auto;
    }
  }
}
</style>
